import React, { useEffect, useState } from "react";

// Evento custom emesso da index.tsx quando il service worker ha messo in cache
// una nuova versione dell'app (hook onUpdate della registrazione).
export const PWA_UPDATE_EVENT = "pwa-update-available";

/**
 * Toast "nuova versione disponibile". Compare in basso quando il service worker
 * ha scaricato un aggiornamento; al click ricarica la pagina per usarlo.
 * Va montato una sola volta a livello globale (vedi App.tsx).
 */
export const PwaUpdateNotification: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onUpdate = () => setVisible(true);
    window.addEventListener(PWA_UPDATE_EVENT, onUpdate);
    return () => window.removeEventListener(PWA_UPDATE_EVENT, onUpdate);
  }, []);

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-lg bg-[var(--tenant-navbar-bg)] px-4 py-3 text-[var(--tenant-navbar-text)] shadow-lg"
    >
      <span className="text-sm">È disponibile una nuova versione.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-md bg-[var(--tenant-navbar-active-bg)] px-3 py-1 text-sm font-semibold text-[var(--tenant-navbar-active-text)] hover:bg-[var(--tenant-navbar-hover-bg)] hover:text-[var(--tenant-navbar-hover-text)]"
      >
        Ricarica
      </button>
      <button
        type="button"
        aria-label="Chiudi"
        onClick={() => setVisible(false)}
        className="text-lg leading-none opacity-70 hover:opacity-100"
      >
        ×
      </button>
    </div>
  );
};
